import React from 'react';
import { Text } from '../../Text';
import { convertToPercentageString } from './CircularProgressBarCore';
import { Size } from '../constants';
import type { CircularProgressBarProps } from '../index.d';
import { Prettify } from '../../utils/typeUtils';

type ProgressLabelProps = Prettify<
  Pick<CircularProgressBarProps, 'value' | 'label'> &
    Required<Pick<CircularProgressBarProps, 'size'>> & {
      'data-skin'?: CircularProgressBarProps['skin'];
    }
>;

const labelSkinMap = {
  standard: 'primary',
  premium: 'premium',
  success: 'success',
} as const;

const labelSizeMap = {
  tiny: undefined,
  small: undefined,
  medium: 'tiny',
  large: 'medium',
} as const;

export const ProgressLabel: React.FC<ProgressLabelProps> = props => {
  const sizeKey = props.size;

  if ([Size.tiny, Size.small].includes(sizeKey)) {
    return <></>;
  }

  const labelSize = labelSizeMap[sizeKey];
  const labelSkin = labelSkinMap[props['data-skin']!];

  return (
    <Text skin={labelSkin} size={labelSize} weight="bold">
      {props.label || convertToPercentageString(props.value as number)}
    </Text>
  );
};
